module.exports = __webpack_public_path__ + "img/Sci-Fi_1.ba2ac773.png";